<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <div v-if="role == 'admin' || role == 'assistant' || role == 'moderator' || role == 'super-moderator'">
      <admin></admin>
    </div>
    <div v-if="role == 'staff'">
      <staff></staff>
    </div>
  </div>
</template>
<script>
import Admin from "@/views/company/dashboard/Admin";
import Staff from "@/views/company/dashboard/Staff";

export default {
  data() {
    return {
      role: "staff"
    };
  },
  components: {
    admin: Admin,
    staff: Staff
  },
  created() {
    let role = this.$store.getters.roles;
    let user = this.$store.getters.currentUser.user_role;
    this.role = user ? user : role;
  }
};
</script>
